export enum MessageTemplateType {
  Email = 'email',
  Sms = 'sms',
  Other = 'other'
}
